export class Features {
    public static main: any[] = [
        {
            name: 'Coaching Community',
            free: true,
            essential: true,
            pro: true
        },
        {
            name: 'Workout Outlines',
            free: true,
            essential: true,
            pro: true
        },
        {
            name: 'Workout/Event Calendar',
            free: true,
            essential: true,
            pro: true
        },
        {
            name: 'Roster Management',
            free: true,
            essential: true,
            pro: true
        },
        {
            name: 'Athlete Testing & Leaderboards',
            free: true,
            essential: true,
            pro: true
        },
        {
            name: 'Detailed Reporting',
            free: true,
            essential: true,
            pro: true
        },
        {
            name: 'Team Page',
            free: true,
            essential: true,
            pro: true
        },
        {
            name: 'Mobile App',
            free: true,
            essential: true,
            pro: true
        },
        {
            name: 'Rotational Workout Timer',
            free: false,
            essential: true,
            pro: true
        },
        {
            name: 'Station Workout Timer',
            free: false,
            essential: true,
            pro: true
        },
        {
            name: 'Sequential Workout Timer',
            free: false,
            essential: true,
            pro: true
        },
        {
            name: 'Freeform Workout Timer',
            free: false,
            essential: true,
            pro: true
        },
        {
            name: 'Data Display',
            free: false,
            essential: false,
            pro: true
        },
        {
            name: 'Test Entry in Mobile App',
            free: false,
            essential: false,
            pro: true
        },
        {
            name: 'Station Mode in Mobile App',
            free: false,
            essential: false,
            pro: true
        },
        {
            name: 'Timer Remote',
            free: false,
            essential: false,
            pro: true
        },
        {
            name: 'Priority Support',
            free: false,
            essential: false,
            pro: true
        },

    ];

    public static teamManager: any[] = [
        {name: 'Seperate Teams'},
        {name: 'Team Dashboard'},
        {name: 'Practice Planner'},
        {name: 'Depth Chart Management'},
        {name: 'Team Messaging'},
        {name: 'Drills'},
        {name: 'Positions'},
        {name: 'Team Feed'},
        {name: 'Practice Timers on Desktop and Mobile'},

    ];
}
